import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Nav,
  NavItem,
  Modal,
  Tab,
  Row,
  Col
} from 'react-bootstrap';
import Moment from 'moment';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';

import * as LotActionType from '../constants';
import { AppSettings } from '../../constants';

import EditLot from './lot-edit';
import ManageRFSLot from './lot-view-rfs-list';
import LotDocument from './lot-view-document';
import OwnershipInfo from './lot-view-ownership-info';

import Translate from 'components/translate';
import ManageNotes from '../Components/ManageNotes';
import MangeLotLocations from './lot-view-locations';

class LotDetail extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    LotStore: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      lotId: this.props.match.params.lotId,
      isViewMode: true,
      isDisplayModalConfirm: false
    };
  }

  componentDidMount() {
    this.onBindingLotDetail();
  }

  // componentWillUnmount() {
  //   this.props.dispatch({
  //     type: LotActionType.RESET_LOT_PROFILE
  //   });
  // }

  onBindingLotDetail = () => {
    console.log('onBindingLotDetail')
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfile();
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === this.state.lotId);
        if (lotFound) { this.onBindHomeownerLotDetail(lotFound.builderProfile); }
        else { this.onGetBuilderProfile(); }
      }
    } else {
      this.props.dispatch({
        type: LotActionType.GET_LOT_BY_ID_ASYNC,
        params: this.state.lotId
      });
    }
  }

  onGetBuilderProfile = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {lotId: this.state.lotId},
      callbackGetBuilderProfile: (builderProfile) => {this.onBindHomeownerLotDetail(builderProfile);}
    });
  }

  onBindHomeownerLotDetail = (builderProfile) => {
    console.log('onBindHomeownerLotDetail')
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_DETAIL_ASYNC,
      params: {
        endpoint: builderProfile.lotDetailEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        }
      },
      callback:(data)=>{
        console.log('Lot details',data)
      }
    });
  }

  onCheckHomeownerOrTenancy = (lotProfileId) => {
    let isHomeowner = true;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === lotProfileId);
      if (lotFound && !lotFound.owner) { isHomeowner = false; }
    }
    return isHomeowner;
  }

  onToggleViewMode = () => {
    this.setState({
      isViewMode: !this.state.isViewMode
    });
  }

  onCustomAction = () => {
    if (this.state.isViewMode) {
      this.props.history.push('/lots');
    } else {
      this.setState({ isDisplayModalConfirm: true });
    }
  }

  onLinkToLot = () => {
    this.props.history.push('/lots');
  }

  handleClose = () => {
    this.setState({ isDisplayModalConfirm: false });
  }

  onSelectTab = (selectedKey) => {
    const queryParams = new URLSearchParams(this.props.location.search);
    if (queryParams.get('active') !== selectedKey) {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: `?active=${selectedKey}`
      });
    }
  }

  renderLotInfoDetail = (data) => {
    if (data) {
      return <strong>{data}</strong>;
    }
    return <span style={{'opacity': '.5'}}>(Not specified)</span>;
  }

  renderLotCOE = (coe) => {
    if (coe) {
      return <strong>{Moment(coe).format('MM/DD/YYYY')}</strong>;
    }
    return <span style={{'opacity': '.5'}}>(Not specified)</span>;
  }

  render() {
    const { LotProfile } = this.props.LotStore;
    if (LotProfile && LotProfile.id) {
      const breadcrumbs = [
        {title: <Translate translateKey='lot' plurals capitalize />, url: '/lots', onCustomAction: this.onCustomAction},
        {title: LotProfile.name || '', url: ''}
      ];
      const queryParams = new URLSearchParams(this.props.location.search);
      const active = queryParams.get('active') ? queryParams.get('active') : 'lot-info';
      return (
        <div>
          <div className='page-title' style={this.props.LotStore.HomeownerLots.length === 1 ? {marginBottom: 30} : {}}>
            <h2>{LotProfile.name + ' - ' + LotProfile.streetAddress}</h2>
          </div>

          {(AppSettings.clientTypeValue !== 'Homeowner' || this.props.LotStore.HomeownerLots.length > 1) &&
          <Breadcrumb breadcrumbs={breadcrumbs} />}

          <div className='wrapper box-form-siteone'>
            <Tab.Container id='lot-detail-tab' defaultActiveKey={active}>
              <Row className='clearfix'>
                <Col sm={12}>
                  <Nav className='lot-info-tab-ul' bsStyle='tabs' onSelect={this.onSelectTab}>
                    <NavItem eventKey='lot-info'><Translate translateKey='lot' capitalize /> info</NavItem>
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <NavItem eventKey='ownership-info'>Ownership info</NavItem>}
                    <NavItem eventKey='request-for-service'>Requests for service</NavItem>
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <NavItem eventKey='location'>Locations</NavItem>}
                    {(this.onCheckHomeownerOrTenancy(LotProfile.id) && AppSettings.clientTypeValue === 'Builder') && <NavItem eventKey='notes'>Notes</NavItem>}
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <NavItem eventKey='documents'>Documents</NavItem>}
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content animation>
                    <Tab.Pane eventKey='lot-info'>
                      {this.state.isViewMode ? (
                        <div className='lot-info-content lot-info-detail'>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'><Translate translateKey='project' plurals capitalize /></label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.projectName)}</span>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Location</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.location)}</span>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'><Translate translateKey='phase' capitalize /></label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.phaseName)}</span>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Plan</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.modelName)}</span>
                            </div>
                          </div>
                          {AppSettings.clientTypeValue !== 'Homeowner' ?  <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Cost center/account</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.projectCode)}</span>
                            </div>
                          </div> : ''}
                          {AppSettings.clientTypeValue !== 'Homeowner' ?  <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Insurance policy</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.insurancePolicy ? LotProfile.insurancePolicy.name : null)}</span>
                            </div>
                          </div> : ''}
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'><Translate translateKey='lot' capitalize /> number</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.name)}</span>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Street address</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.streetAddress)}</span>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Original COE</label>
                              <span className='lot-info-value'>{this.renderLotCOE(LotProfile.coe)}</span>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <label className='lot-info-label'>Note</label>
                              <span className='lot-info-value'>{this.renderLotInfoDetail(LotProfile.note)}</span>
                            </div>
                          </div>
                          {AppSettings.clientTypeValue !== 'Homeowner' &&
                          <div className='row'>
                            <div className='form-group col-sm-8'>
                              <div className='col-sm-12'>
                                <button
                                  className='btn btn-primary btn-info btn-siteone'
                                  onClick={this.onToggleViewMode}>Edit</button>
                              </div>
                            </div>
                          </div>
                          }
                        </div>
                      ) : (
                        <EditLot
                          onToggleViewMode={this.onToggleViewMode}
                          LotProfile={LotProfile} />
                      )}
                    </Tab.Pane>
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <Tab.Pane eventKey='ownership-info'>
                      <OwnershipInfo location={this.props.location} history={this.props.history}/>
                    </Tab.Pane>
                    }
                    <Tab.Pane eventKey='request-for-service'>
                      {active === 'request-for-service' &&
                      <ManageRFSLot location={this.props.location} history={this.props.history} lotId={this.state.lotId}/>
                      }
                    </Tab.Pane>

                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <Tab.Pane eventKey='location'>
                      {active === 'location' &&
                      <MangeLotLocations dispatch={this.props.dispatch} history={this.props.history} lotId={this.state.lotId} />
                      }
                    </Tab.Pane>
                    }
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <Tab.Pane eventKey='notes'>
                      {
                        AppSettings.clientTypeValue === 'Builder' &&
                      <ManageNotes dispatch={this.props.dispatch} history={this.props.history} lotId={this.state.lotId} />
                      }
                    </Tab.Pane>
                    }
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && <Tab.Pane eventKey='documents'>
                      {active === 'documents' &&
                      <LotDocument location={this.props.location} history={this.props.history} lotId={this.state.lotId} />
                      }
                    </Tab.Pane>
                    }
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>

          <Modal show={this.state.isDisplayModalConfirm} onHide={this.handleClose} style={{top: '20%'}}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>All information will be discarded. Continue?</p>
            </Modal.Body>
            <Modal.Footer>
              <div className='text-right'>
                <button
                  className='btn btn-primary btn-info btn-siteone'
                  onClick={this.handleClose}>No</button>
                <button
                  className='btn btn-primary btn-siteone-default'
                  style={{marginLeft: 10}}
                  onClick={this.onLinkToLot}>Yes</button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    LotStore: state.LotStore
  };
};

export default connect(mapStateToProps)(LotDetail);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view.js